<div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
    <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
        <h3 class="mb-0 mt-0">{{ userAttribute.translationKey | translate }}</h3>

        <app-search-outline [searchInput]="searchInput" *ngIf="userAttribute.options.length"></app-search-outline>
    </div>

    <div #optionsTableScrollHost class="w-100-p table-wrapper white" *ngIf="dataSource && userAttribute.options.length; else noData">
        <span id="ruler" class="ruler"></span>

        <mat-table #table [dataSource]="dataSource.data | filterAttributeOption: searchInput.value" matSort>
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="pl-24 pr-8" *matHeaderCellDef></mat-header-cell>

                <mat-cell #nameCell *matCellDef="let extendedAttributeOption" class="pl-24 pr-8" fxLayout="column" fxLayoutAlign="center start">
                    <span class="text-truncate font-semibold w-100-p">{{
                        userAttribute.type === ExtendedAttributeType.Number ? extendedAttributeOption.valueNumber : (extendedAttributeOption.translationKey | translate)
                    }}</span>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>

                <mat-cell *matCellDef="let extendedAttributeOption">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(extendedAttributeOption)" *ngIf="!extendedAttributeOption.selected"></app-flat-button>

                        <app-white-button
                            [label]="'GENERAL.BUTTON.UNSELECT'"
                            (onClick)="removeFromList(extendedAttributeOption)"
                            *ngIf="extendedAttributeOption.selected"
                        ></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row
                *matRowDef="let extendedAttributeOption; columns: displayedColumns"
                [attr.data-option-selected-row]="extendedAttributeOption.selected ? true : null"
                matRipple
            >
            </mat-row>
        </mat-table>
    </div>
    <ng-template #noData>
        <div class="no-options-container flex min-h-0 flex-1 flex-col" fxLayout="column">
            <div fxLayout="column" fxLayoutAlign="center center">
                <mat-icon svgIcon="empty"></mat-icon>
                <p class="mt-12 mb-24">{{ 'GENERAL.MESSAGE.NO_DEFINED_OPTIONS' | translate }}</p>
            </div>
        </div>
    </ng-template>
</div>
